export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/index.cbd598fa.worker.js");
}
